import { ReactNode } from 'react'

import { Trans } from '@/components/Trans'
import { cn } from '@/utils/style'

interface ExpirationBehaviorProps {
  value: boolean
  onChange: (value: boolean) => void
  className?: string
}

const OPTIONS: { label: ReactNode; value: boolean }[] = [
  {
    label: (
      <Trans i18nKey="create.ExpirationBehaviorSection.switchToPayAsYouGo">
        Continue running with Pay-As-You-Go
      </Trans>
    ),
    value: true,
  },
  {
    label: (
      <Trans i18nKey="create.ExpirationBehaviorSection.releaseInstance">Release Instance</Trans>
    ),
    value: false,
  },
]

export function ExpirationBehavior({ value, onChange, className }: ExpirationBehaviorProps) {
  return (
    <div>
      <div className="flex justify-start gap-2">
        {OPTIONS.map((opt) => {
          const selected = value === opt.value
          return (
            <button
              key={String(opt.value)}
              type="button"
              className={cn(
                'flex items-center justify-start gap-2 rounded-xl border px-4 py-2 text-sm transition-colors',
                className,
                selected
                  ? 'border-secondary text-primary font-semibold'
                  : 'border-neutral-200 bg-panel-white text-secondary hover:bg-neutral-50',
              )}
              onClick={() => onChange(opt.value)}
            >
              <span
                className={cn(
                  'flex h-4 w-4 items-center justify-center rounded-full border',
                  selected ? 'bg-btn-secondary dark:border-btn-secondary' : 'border-neutral-300',
                )}
              >
                <span
                  className={cn(
                    'h-1.5 w-1.5 rounded-full',
                    selected ? 'bg-panel-white' : 'bg-transparent',
                  )}
                />
              </span>
              <span className="t-sb">{opt.label}</span>
            </button>
          )
        })}
      </div>
      {value === true && (
        <div className="t-xs text-tertiary mt-2">
          <Trans i18nKey="create.AutoRenewalSectionContent.content">
            Continue running your instance with pay-as-you-go billing after the subscription
            expires. Make sure your account has sufficient credits.
          </Trans>
        </div>
      )}
    </div>
  )
}
